import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 8px 24px;
  background: ${NeutralColors[0]};
  border-bottom: 1px solid ${NeutralColors[20]};
  box-shadow: ${props => props.theme.boxShadow};
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Logo = styled.img`
  max-height: 48px;
`;

export const Divider = styled.span`
  width: 1px;
  height: 32px;
  background: ${NeutralColors[20]};
`;

export const Title = styled.span`
  font-family: 'Noto Sans', sans-serif;
  font-size: 20px;
  font-weight: 400;
  color: ${NeutralColors[100]};
`;

export const Selectors = styled.div<{ $gap: number }>`
  display: flex;
  align-items: center;
  gap: ${({ $gap }) => `${$gap}px`};
`;
